import angular from 'angular';

export default function GeozoneService($http, appSettings) {
  'ngInject';

  var equipmentGeozoneSRVs = {};

  var equipmentGeozonesEndpoint = appSettings.InReachApiGeozonesEndpoint;

  equipmentGeozoneSRVs.getAllGeozones = function () {
    return $http.get(equipmentGeozonesEndpoint);
  };

  equipmentGeozoneSRVs.getGeozoneById = function (geozoneid) {
    return $http.get(equipmentGeozonesEndpoint + '/' + geozoneid);
  };

  equipmentGeozoneSRVs.getGeozoneByName = function (geozonename) {
    return $http.get(equipmentGeozonesEndpoint + '/' + geozonename);
  };

  equipmentGeozoneSRVs.putGeozoneById = function (geozoneid, newZone) {
    var endpoint = equipmentGeozonesEndpoint + '/' + geozoneid;

    return $http.put(endpoint, newZone);
  };

  //productSRVs.getTriggersBySchemaId = function (schemaId) {
  //    return $http.get(equipmentGeozonesEndpoint + "/" + schemaId + "/triggers");
  //}

  equipmentGeozoneSRVs.getEquipmentInZone = function (geozoneId) {
    return $http.get(equipmentGeozonesEndpoint + '/' + geozoneId + '/equipment');
  };

  equipmentGeozoneSRVs.postNewEquipmentGeozone = function (geozone) {
    var body = angular.copy(geozone);
    if (geozone.alertRule.priority == '') {
      body.alertRule.priority = 'low';
    }
    return $http.post(equipmentGeozonesEndpoint, body);
  };

  equipmentGeozoneSRVs.deleteEquipmentGeozone = function (geozoneid) {
    return $http.delete(equipmentGeozonesEndpoint + '/' + geozoneid);
  };

  equipmentGeozoneSRVs.addEquipmentInZone = function (geozoneId, equipmentIdList) {
    var endpoint = equipmentGeozonesEndpoint + '/' + geozoneId + '/equipment';
    var changeSet = {};
    changeSet.op = 'add';
    changeSet.values = [];
    for (var i = 0; i < equipmentIdList.length; i++) {
      changeSet.values.push(equipmentIdList[i]);
    }

    return $http.patch(endpoint, changeSet);
  };

  equipmentGeozoneSRVs.deleteEquipmentInZone = function (geozoneId, equipmentIdList) {
    var endpoint = equipmentGeozonesEndpoint + '/' + geozoneId + '/equipment';
    var changeSet = {};
    changeSet.op = 'remove';
    changeSet.values = [];
    for (var i = 0; i < equipmentIdList.length; i++) {
      changeSet.values.push(equipmentIdList[i]);
    }

    return $http.patch(endpoint, changeSet);
  };

  equipmentGeozoneSRVs.log = function (geozoneId) {
    var endpoint = equipmentGeozonesEndpoint + '/' + geozoneId + '/log';
    return $http.get(endpoint);
  };

  return equipmentGeozoneSRVs;
}